import apiClient from "QueryClient/axiosClient";
import { getLastRecommendationCorrelationId } from "Features/CollegeFinder/registrationFlow";

export const getCollegeRecommendations = async (accountId) => {
  const correlationId = getLastRecommendationCorrelationId(accountId);
  const response = await apiClient.get(
    "/collegeFinder/getRecommendations",
    correlationId
      ? { headers: { "X-Request-ID": correlationId } }
      : undefined
  );
  return response.data;
};
